enum PlanType {
    BASIC        = 'basic',
    PROFESSIONAL = 'professional',
    PREMIUM      = 'premium',
}

export default PlanType;
